import type { ReactElement } from 'react';

import { cn } from '@/lib/utils';

interface FormFieldProps {
  readonly label: string;
  readonly children: ReactElement;
  readonly className?: string;
  /**
   * Mark the field as required — renders a red `*` after the label (PTV2-1301). Use for the fields
   * that must be filled before the form's Save/Add button enables.
   */
  readonly required?: boolean;
}

/**
 * Label-wrapped form input used by the patient-record edit dialogs.
 * Replaces the per-section ad-hoc `<label>` wrappers.
 */
export function FormField({
  label,
  children,
  className,
  required = false,
}: FormFieldProps): ReactElement {
  return (
    <label className={cn('block space-y-2 text-xs font-medium', className)}>
      <div className='pb-0.5'>
        {label}
        {required && (
          <span className="ml-0.5 text-destructive" aria-hidden="true">
            *
          </span>
        )}
      </div>
      {children}
    </label>
  );
}
